import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LayoutState {
  circlePosition: "top" | "bottom";
}

const initialState: LayoutState = {
  circlePosition: "top",
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setCirclePosition: (state, action: PayloadAction<"top" | "bottom">) => {
      state.circlePosition = action.payload;
    },
  },
});

export const { setCirclePosition } = layoutSlice.actions;
export default layoutSlice.reducer;
